var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-container",style:(_vm.containerStyle)},_vm._l((_vm.rowCount),function(i){return _c('div',{key:i,staticClass:"article-item",style:(_vm.itemStyle)},[(_vm.showAvatar)?_c('div',{staticClass:"avatar",style:({
        width: _vm.avatarSize + 'px',
        height: _vm.avatarSize + 'px',
        marginRight: _vm.gutter + 'px'
      })}):_vm._e(),_c('div',{staticClass:"content"},[_c('div',{staticClass:"title-line",style:({ 
          width: _vm.titleWidth,
          height: _vm.lineHeight + 'px'
        })}),(_vm.showMeta)?_c('div',{staticClass:"meta-line",style:({ 
          width: _vm.metaWidth,
          height: _vm.lineHeight + 'px'
        })}):_vm._e(),_vm._l((_vm.lines),function(line){return _c('div',{key:line,staticClass:"content-line",style:({ 
          width: _vm.getLineWidth(line),
          height: _vm.lineHeight + 'px'
        })})})],2)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }